import axios from 'axios'
import router from '@/router'
import store from '@/store'
import qs from 'qs'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,//process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL : '/api',
  timeout: 60000
})

//request interceptors:
service.interceptors.request.use(
  config => {
    config.headers['Authorization'] = store.getters['userInfo/token']

    // 对于参数是数组的处理
    if (config.method === 'get') {
      config.paramsSerializer = function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//response interceptors:
service.interceptors.response.use(
  response => {
    if (response.data.code === 401) {
      store.commit('userInfo/Mutation_REMOVE_TOKEN')
      if (router.currentRoute.path !== '/login') {
        router.replace('/login')
      }
    } else {
      return response.data
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service

export function postFetch(...args) {
  return axios.post(...args).then(
    res => {
      if (res.data.code == 200) {
        return Promise.resolve(res.data)
      }
      return Promise.reject(res.data)
    },
    error => {
      // message.error(error.message || error.data.message || error.data.msg)
      // message.error('网络错误，请稍后重试');
      return Promise.reject(error)
    }
  )
}
